import { render } from "./comment_treatment_plan.svg.vue?vue&type=template&id=2859ec5f"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__